import React from 'react';
import '../assets/Shops.css';
import '../App.css';

export const AddType: React.FC<{
  onAddPhone: () => void;
  onAddManual: () => void;
  onBack?: () => void;
}> = ({ onAddPhone, onAddManual, onBack }) => (
  <div className="form-card">
    <div className="form-card__head">
      <h2 className="form-card__title">Add a shop</h2>
      <p className="form-card__sub">Pick how you want to onboard them.</p>
    </div>

    <div className="choice-list">
      <button className="choice" onClick={onAddPhone}>
        <span className="choice__title">Invite by phone</span>
        <span className="choice__desc">
          We message the shop on WhatsApp and they send their own details and location.
        </span>
      </button>
      <button className="choice" onClick={onAddManual}>
        <span className="choice__title">Add manually</span>
        <span className="choice__desc">
          Enter the shop’s details and drop a pin on the map yourself.
        </span>
      </button>
    </div>

    {onBack && (
      <button className="btn btn--secondary btn--block" onClick={onBack}>Back</button>
    )}
  </div>
);
